import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/cn";

function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

export function PageHeader({
  title,
  description,
  breadcrumbs,
  action,
  showGreeting = true,
  greetingOnly = false,
  userName = "there",
}: {
  title?: string;
  description?: string;
  breadcrumbs?: { label: string; href?: string }[];
  action?: React.ReactNode;
  showGreeting?: boolean;
  greetingOnly?: boolean;
  userName?: string;
}) {
  const greeting = getGreeting();

  return (
    <header className="space-y-3">
      {breadcrumbs && breadcrumbs.length > 0 ? (
        <nav className="flex flex-wrap items-center gap-1 text-sm text-muted">
          {breadcrumbs.map((crumb, i) => (
            <span key={crumb.label} className="flex items-center gap-1">
              {i > 0 ? <ChevronRight className="h-3.5 w-3.5" /> : null}
              {crumb.href ? (
                <Link to={crumb.href} className="transition-colors hover:text-foreground">
                  {crumb.label}
                </Link>
              ) : (
                <span className="font-semibold text-foreground">{crumb.label}</span>
              )}
            </span>
          ))}
        </nav>
      ) : null}

      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          {greetingOnly && showGreeting ? (
            <h1 className="text-[2.75rem] font-extrabold leading-[1.05] tracking-[-0.035em] text-foreground">
              {greeting},{" "}
              <span className="bg-gradient-to-r from-foreground via-[#3f7314] to-foreground bg-clip-text text-transparent">
                {userName}
              </span>
            </h1>
          ) : (
            <>
              {showGreeting ? (
                <p className="text-sm font-medium text-muted">
                  {greeting}, <span className="font-semibold text-foreground">{userName}</span>
                </p>
              ) : null}
              {title ? (
                <h1
                  className={cn(
                    "font-extrabold tracking-[-0.035em] text-foreground",
                    showGreeting ? "mt-1 text-[2.75rem] leading-[1.05]" : "text-[2.75rem] leading-[1.05]"
                  )}
                >
                  {title}
                </h1>
              ) : null}
            </>
          )}
          {description ? (
            <p className="mt-3 max-w-2xl text-[0.9375rem] font-medium leading-relaxed text-muted">
              {description}
            </p>
          ) : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
    </header>
  );
}
